import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { environment } from 'src/environments/environment';
import { BasicLoadConfigurationOptionsComponent } from '~modules/connectors/modules/load/common/components/basic-configuration-options/basic-load-configuration-options.component';
import { FileDownloadFieldsConfiguration } from '~modules/connectors/services/extract-connectors-configurations/field-type';

@Component({
  selector: 'app-load-dex-download-configuration',
  templateUrl: './load-dex-download-configuration.component.html',
  standalone: true,
  providers: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule,
    MatRadioModule,
    MatTooltipModule,
    MatSlideToggleModule,
    BasicLoadConfigurationOptionsComponent
  ]
})
export class LoadDexDownloadConfigurationComponent {
  formGroup!: FormGroup;
  configuration?: FileDownloadFieldsConfiguration;
  configurationMode: string | undefined;

  @Input()
  set configMode(configMode: string | undefined) {
    this.configurationMode = configMode;
  }

  @Input()
  set config (config: FileDownloadFieldsConfiguration | null) {
    if (config != null) {
      this.configuration = config;
    }
  }

  get documentationImportUrl() {
    return environment.documentation.dex.import;
  }

  constructor(
    private readonly fb: FormBuilder,
  ) {
    this.formGroup = fb.group({
      folderId: [null, [Validators.required, Validators.maxLength(8)]],
    });
  }
}
